// Public entrypoint for the search feature.

export { searchRepository } from "./data/repositories/search.repository";
export { getSearchResults, getSearchSuggestions } from "./server/queries/search";
export { SearchPage } from "./presentation/pages/search-page";
export { DashboardSearchPage } from "./presentation/pages/dashboard-search-page";
export { HealerListingPage } from "./presentation/pages/healer-listing-page";
export type { HealerListingFilters } from "./presentation/pages/healer-listing-page";
export { DashboardSearch } from "./presentation/components/dashboard-search";
export { HealerResultCard } from "./presentation/components/search-result-cards";
export { useSearch } from "./presentation/hooks/use-search";
export type {
  SearchParams,
  SearchMode,
  SearchType,
  SearchSort,
  SearchResponse,
  SearchResultsResponse,
  SearchSuggestResponse,
  SearchGroupedResults,
  SearchHealerResult,
  SearchBlogResult,
  SearchSuggestion,
  SearchFacetItem,
  Gender,
} from "./types";
